import axios from "axios";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";

const createAxios = (baseURL, contentType = "application/json") => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": contentType,
    },
  });

  instance.interceptors.request.use(async (req) => {
    const token = JSON.parse(localStorage.getItem("accessToken"));
    const user = token && jwtDecode(token?.accessToken);
    const isExpired = user && dayjs.unix(user.exp).diff(dayjs()) < 1;

    if (isExpired) {
      localStorage.clear();
      window.location.replace("/");
    }

    if (token?.accessToken) {
      req.headers.Authorization = `Bearer ${token.accessToken}`;
    }

    return req;
  });

  return instance;
};

const api = createAxios(process.env.REACT_APP_BACKEND_URL);
export const formApi = createAxios(process.env.REACT_APP_BACKEND_URL);
export const walletApi = createAxios(process.env.REACT_APP_WALLET_URL);
export const reportingUrl = createAxios(process.env.REACT_APP_REPORT_URL);
export const reportingDevUrl = createAxios(process.env.REACT_APP_REPORTING_URL);
export const configDevUrl = createAxios(process.env.REACT_APP_CONFIG_URL);
export const walletDevUrl = createAxios(process.env.REACT_APP_WALLET_URL);
export const analyticsDevUrl = createAxios(
  process.env.REACT_APP_ANALYTICS_URL
);

export default api;
